import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var ArrowRight = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M3.89 16a1 1 0 011-1h19.59l-7.29-7.29a1 1 0 01.7-1.71 1 1 0 01.71.29l9 9a1 1 0 01.22.33 1.07 1.07 0 010 .76 1 1 0 01-.22.33l-9 9a1 1 0 01-1.41 0 1 1 0 010-1.42L24.48 17H4.89a1 1 0 01-1-1z" })), '0 0 32 32', 'ArrowRight');
//# sourceMappingURL=ArrowRight.js.map